import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/studio.css'
import './assets/workspace-overrides.css'

createApp(App).use(router).mount('#app')
